<template>
	<div class="privacy">
		<!-- Content -->
		<div class="container">
      <p v-html="page.content"></p>
		</div>
    <crowd-or-rais></crowd-or-rais>
	</div>
</template>

<script>
import CrowdOrRais from '@/components/CrowdOrRais';
import pagesApi from '@/api/v1/pages';

export default {
  components: { CrowdOrRais },
  data() {
    return {
      page: '',
    };
  },
  methods: {
    getStaticPage() {
      pagesApi.getPage(this.$route.params.permalink, (page) => { this.page = page; });
    },
  },
  created() {
    this.getStaticPage();
  },
  watch: {
    $route() {
      this.getStaticPage();
    },
  },
};
</script>



// WEBPACK FOOTER //
// StaticPages.vue?188d9a28